"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricTypes = {
    COUNTER: 'counter',
    GAUGE: 'gauge',
    TIMER: 'timer',
};
function asNanoseconds(n) {
    return n;
}
exports.asNanoseconds = asNanoseconds;
const Batching = {
    queue: [],
    timeout: undefined,
    flush() {
        reportMetrics(this.queue);
        this.queue = [];
        this.timeout = undefined;
    },
};
class SemanticMetrics {
    static init(config) {
        SemanticMetrics.config = config;
        if (typeof config.batching === 'undefined') {
            config.batching = { delay: 4000 };
        }
        if (config.batching &&
            typeof window === 'object' &&
            typeof window.addEventListener === 'function') {
            window.addEventListener('beforeunload', () => {
                this.isWindowUnloading = true;
                Batching.flush();
            });
        }
    }
}
SemanticMetrics.isWindowUnloading = false;
function sendMetric(metric) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        if (!SemanticMetrics.config) {
            throw new Error('SemanticMetrics has not been initialized');
        }
        if (typeof SemanticMetrics.config.dev !== 'undefined'
            ? SemanticMetrics.config.dev
            : process &&
                (process.env.NODE_ENV === 'dev' ||
                    process.env.NODE_ENV === 'development')) {
            return;
        }
        const clonedMetric = Object.assign({}, metric);
        if (metric.tags) {
            clonedMetric.tags = Object.assign({}, metric.tags);
        }
        clonedMetric.key = clonedMetric.key || SemanticMetrics.config.key;
        if (!clonedMetric.key) {
            throw new Error(`metric.key is required. Got: "${clonedMetric.key}". Set it in SemanticMetrics.init() or pass it to sendMetric().`);
        }
        clonedMetric.tags = Object.assign({ app: (_a = SemanticMetrics.config.app, (_a !== null && _a !== void 0 ? _a : clonedMetric.key)) }, clonedMetric.tags);
        if (SemanticMetrics.config.component_id) {
            clonedMetric.component_id =
                clonedMetric.component_id || SemanticMetrics.config.component_id;
        }
        else {
            clonedMetric.component_id = SemanticMetrics.config.key;
        }
        if (SemanticMetrics.config.batching && !SemanticMetrics.isWindowUnloading) {
            Batching.queue.push(clonedMetric);
            if (!Batching.timeout) {
                Batching.timeout = setTimeout(() => Batching.flush(), SemanticMetrics.config.batching.delay);
            }
        }
        else {
            yield reportMetrics([clonedMetric]);
        }
        return;
    });
}
exports.sendMetric = sendMetric;
function reportMetrics(metrics) {
    return __awaiter(this, void 0, void 0, function* () {
        if (Array.isArray(SemanticMetrics.config.reporter)) {
            const reporterPromises = SemanticMetrics.config.reporter.map(reporter => reporter.send(metrics));
            yield Promise.all(reporterPromises);
        }
        else {
            yield SemanticMetrics.config.reporter.send(metrics);
        }
    });
}
exports.default = SemanticMetrics;
//# sourceMappingURL=SemanticMetrics.js.map